/*
  TIKITAKA Homepage Modules
  JS 按 section root 作用域执行，支持同一页面重复添加模块，避免互相影响。
*/

(() => {
  const initHero = (root) => {
    const slides = root.querySelectorAll('[data-tt-hero-slide]');
    const dots = root.querySelectorAll('[data-tt-hero-dot]');
    const autoplayMs = Number(root.dataset.autoplayMs || 5000);
    if (!slides.length) return;

    let index = 0;
    let timer = null;

    const setIndex = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, n) => slide.classList.toggle('is-active', n === index));
      dots.forEach((dot, n) => dot.classList.toggle('is-active', n === index));
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (slides.length > 1 && autoplayMs > 0) {
        timer = window.setInterval(() => setIndex(index + 1), autoplayMs);
      }
    };

    dots.forEach((dot, n) => {
      dot.addEventListener('click', () => {
        setIndex(n);
        start();
      });
    });

    start();
  };

  const initLineup = (root) => {
    const grid = root.querySelector('[data-tt-lineup-grid]');
    const chips = root.querySelectorAll('[data-tt-lineup-filter]');
    if (!grid || !chips.length) return;

    const cards = grid.querySelectorAll('[data-tt-lineup-card]');

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((item) => item.classList.remove('is-active'));
        chip.classList.add('is-active');

        const filter = (chip.dataset.ttLineupFilter || 'all').toLowerCase();
        let visibleCount = 0;

        cards.forEach((card) => {
          const searchable = (card.dataset.ttLineupSearch || '').toLowerCase();
          const isVisible = filter === 'all' || searchable.includes(filter);
          card.classList.toggle('is-hidden', !isVisible);
          if (isVisible) visibleCount += 1;
        });

        grid.classList.toggle('is-empty', visibleCount === 0);
      });
    });
  };

  const init = () => {
    document.querySelectorAll('[data-tt-home-hero]').forEach(initHero);
    document.querySelectorAll('[data-tt-home-lineup]').forEach(initLineup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
